import dynamic from "next/dynamic";

export const Form = dynamic(() => import("./component"));
